import copy from 'copy-to-clipboard';
import isAllowedToDeleteInvitation from '../../../permissions/is-allowed-to-delete-invitation';
import { useInvitationConfirmDeleteContext } from '../../../context/InvitationConfirmDeleteContextProvider';

export const useBuildMenuItems = row => {
  const { onOpen } = useInvitationConfirmDeleteContext();
  const hasPermission = isAllowedToDeleteInvitation();

  const items = [
    {
      label: 'Delete',
      onClick: () => onOpen(row),
      props: { disabled: !hasPermission },
    },
  ];

  if (row.invitationUrl) {
    items.push({
      label: 'Copy URL',
      onClick: () => copy(row.invitationUrl),
    });
  }

  return items;
};
